import { Suspense, useState } from 'react';

import PropTypes from 'prop-types';

import BarChartIcon from '@mui/icons-material/BarChart';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import { Box, IconButton } from '@mui/material';

import { CircularLoaderComponent } from '../LoadingSpinner/LoadingSpinnerComponent';
import MultiFilterSelectComponent from './MultiFilterSelectComponent';

import { lazyImport } from '../Main/utils';

import ErrorBoundary from '../Main/ErrorBoundary';

const ChartContainer = lazyImport(() => import('../Chart'), 'Chart');

const FiltersComponent = (props) => {
  const {
    filters,
    onChange,
    action,
    SearchComponent,
    DateRangeComponent,
    showTableRowsOnly,
    chartMetadata,
    isLoading,
    hasToggleFilters,
  } = props;

  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const [isChartOpen, setIsChartOpen] = useState(false);

  const toggleChart = () => {
    isFilterOpen && setIsFilterOpen(false);
    setIsChartOpen(!isChartOpen);
  };

  const toggleFilter = () => {
    isChartOpen && setIsChartOpen(false);
    setIsFilterOpen(!isFilterOpen);
  };
  const hasActions = Boolean(action?.props?.actions?.length);

  return (
    <Box
      id="search_and_filter"
      display="flex"
      flexDirection="column"
      style={showTableRowsOnly ? { height: 0, overflow: 'hidden' } : {}}
    >
      <Box width="100%" display="flex" alignItems="center" sx={{ mb: '1rem' }}>
        {SearchComponent ? (
          <>
            {SearchComponent}

            {chartMetadata?.chartId ? (
              <Box ml="1rem">
                <IconButton
                  onClick={toggleChart}
                  aria-label="Chart"
                  size="large"
                  sx={{ padding: 0 }}
                >
                  <BarChartIcon fontSize="large" />
                </IconButton>
              </Box>
            ) : null}

            {filters?.length && hasToggleFilters ? (
              <Box ml="1rem">
                <IconButton
                  onClick={toggleFilter}
                  aria-label="Filters"
                  size="large"
                  sx={{ padding: 0 }}
                >
                  <FilterListOutlinedIcon fontSize="large" />
                </IconButton>
              </Box>
            ) : null}
          </>
        ) : null}
        {hasActions && <Box ml="1rem">{action}</Box>}
      </Box>
      {filters?.length ? (
        <Box
          width="100%"
          display="flex"
          alignItems="center"
          style={{
            display: isFilterOpen ? 'flex' : 'none',
          }}
        >
          <MultiFilterSelectComponent
            filters={filters}
            onChange={onChange}
            dateRange={DateRangeComponent}
            isLoading={isLoading}
          />
        </Box>
      ) : null}
      {isChartOpen ? (
        <Suspense fallback={<CircularLoaderComponent />}>
          <ErrorBoundary>
            <ChartContainer chartMetadata={chartMetadata} />
          </ErrorBoundary>
        </Suspense>
      ) : null}
    </Box>
  );
};

FiltersComponent.propTypes = {
  filters: PropTypes.instanceOf(Array),
  onChange: PropTypes.func,
  action: PropTypes.instanceOf(Object),
  SearchComponent: PropTypes.node,
  DateRangeComponent: PropTypes.node,
  showTableRowsOnly: PropTypes.bool,
  chartMetadata: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool,
  hasToggleFilters: PropTypes.bool,
};

export default FiltersComponent;
